var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"page-hero-wrapper d-flex flex-column justify-end position-relative",class:{
    'with-aspect-ratio': !!_vm.aspectRatio,
    'with-max-height': _vm.maxHeight !== undefined,
    'with-min-height': _vm.minHeight !== undefined,
    'aspect--2-1': _vm.aspectRatio === 2,
    'aspect--16-9': _vm.aspectRatio === 16 / 9,
    'aspect--1': _vm.aspectRatio === 1,
    [_vm.containerClass]: !!_vm.containerClass,
  },style:(_vm.style)},[_vm._t("leftContent"),_vm._v(" "),(_vm.backgroundImage)?_c('div',{ref:"imgContainer",class:{
      [_vm.imgContainerClass]: !!_vm.imgContainerClass,
    }},[_c('img',{staticClass:"d-none",attrs:{"src":_vm.backgroundImage,"alt":""},on:{"load":_vm.handleImageLoaded}})]):_vm._e(),_vm._v(" "),(_vm.showHeroInner)?[_c('div',{class:{ [_vm.bgOverlayClass]: !!_vm.bgOverlayClass }}),_vm._v(" "),_c('div',{staticClass:"flex-grow-1 d-flex flex-column justify-end position-relative"},[_c('div',{class:{ [_vm.heroContainerClass]: !!_vm.heroContainerClass }},[_c('div',{class:{
            [_vm.innerContainerClass]: !!_vm.innerContainerClass,
          }},[_vm._t("default")],2)])])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }